import { BorderRadius, Color, getShadow, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ReportContentWrapper = styled.table`
  flex: 1;
  border-radius: ${BorderRadius.R12};
  background-color: ${Color.White};
  overflow: hidden;
  ${getShadow('raisedLight')};
`

export const SectionRow = styled.div`
  height: 48px;
  background-color: ${Color.Black};
`

export const HeadCell = styled.th`
  height: 48px;
  padding: ${Spacing.S16} ${Spacing.S32};
  background-color: ${Color.Grey100};

  &:first-child {
    width: 100%;
  }
`

export const BodyCell = styled.td`
  padding: ${Spacing.S16} ${Spacing.S32};
  border-bottom: 1px solid ${Color.Grey150};

  &:first-child {
    display: flex;
    gap: ${Spacing.S16};
  }
`

export const AsideWrapper = styled.div`
  flex: 0;
  min-width: 220px;
`
